"use client";
import React from "react";
import useSingletonHotkey from "./_private/useSingletonHotkeys.js";
const useHotkeys = (hotkeys, deps = [], options) => {
    const { addHotkeys, isPressed } = useSingletonHotkey();
    const generatedRef = React.useRef(null);
    const elementRef = options?.ref || generatedRef;
    React.useEffect(() => {
        const remove = addHotkeys(hotkeys, elementRef);
        return () => remove?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addHotkeys, Object.keys(hotkeys).join(","), ...deps]);
    return { ref: elementRef, checkHotkeyState: isPressed };
};
export default useHotkeys;
